import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-8 mb-10 flex flex-col" }
const _hoisted_2 = { class: "text-2xl text-light4 -mb-2 uppercase font-black truncate" }
const _hoisted_3 = { class: "text-6xl leading-tight font-black" }
const _hoisted_4 = { class: "text-4xl" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "inline-block text-center text-4xl"
}

import BaseButton from "@/components/Button/BaseButton.vue";
import BUTTONTYPE from "@/components/Button/Button.types";
import { remainingTimeOfReservationInfo } from "@/helpers/Time";
import { computed, onMounted, ref } from "vue";
import { useProfileStore } from "@/store/Profile";
import { useScheduleStore } from "@/store/Schedule";
import ErrorModal from "@/components/Modal/ErrorModal.vue";
import loggingService from "@/services/LoggingService";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const profileStore = useProfileStore();
const scheduleStore = useScheduleStore();

const useNowErrorModal = ref(false);
const isUseNowLoading = ref(false);

onMounted(() => {
  loggingService.info("Available.vue", "🟩 Available view mounted");
});

const onUseNowButton = async () => {
  loggingService.info("Available.vue", "Use now action");
  isUseNowLoading.value = true;

  const useNowResponse = await scheduleStore.useNowResource();
  if (useNowResponse.error) {
    isUseNowLoading.value = false;
    loggingService.error("Available.vue", `❗️ Failed to use resource now ${useNowResponse.error}`);
    useNowErrorModal.value = true;

    return;
  }

  isUseNowLoading.value = false;
};

const { t } = useI18n();

const availability = computed(() => {
  if (!scheduleStore.firstFutureReservation) return t("untilTheEndOfDay");

  const diffTime = remainingTimeOfReservationInfo(scheduleStore.firstFutureReservation, scheduleStore.getTime);
  if (!diffTime) return "";

  const { diffHours, diffMinutes } = diffTime;
  const remainingHours = diffHours !== 0 ? t("remainingHours", { diffHours }) : "";
  const remainingMinutes = diffMinutes !== 0 ? t("remainingMinutes", { diffMinutes }) : "";
  return t("remainingFor", { remainingHours, remainingMinutes });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-col",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closeUpcoming')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("resourceName", { resourceName: _unref(profileStore).resourceName })), 1),
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("availableNow")), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(availability)), 1)
    ]),
    (_unref(profileStore).allowForLocalReservation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(BaseButton, {
            type: _unref(BUTTONTYPE).PRIMARY,
            "full-width": "",
            class: "text-3xl",
            disabled: isUseNowLoading.value,
            loading: isUseNowLoading.value,
            onClick: onUseNowButton
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("useNow")), 1)
            ]),
            _: 1
          }, 8, ["type", "disabled", "loading"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t("forReservationUseWebsite")), 1)),
    (useNowErrorModal.value)
      ? (_openBlock(), _createBlock(ErrorModal, {
          key: 2,
          "error-message": "roomNotAvailable",
          onClose: _cache[0] || (_cache[0] = ($event: any) => (useNowErrorModal.value = false))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})